import { reducer as franchisesReducer } from './franchises.slice';

export default franchisesReducer;
